import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { AttributionTypeDTO, statusEnum } from '../model/user-profiles-model';
import { UserProfilesStore } from '../user-profiles-service/user-profiles-service.store';

@Component({
  selector: 'app-manage-attribution',
  templateUrl: './manage-attribution.component.html',
  styleUrls: ['./manage-attribution.component.scss'],
})
export class ManageAttributionComponent implements OnInit {
  displayedColumns: string[] = ['code', 'description'];

  updateAttributionForm: FormGroup;
  attributionsList: AttributionTypeDTO[];

  constructor(
    private formBuilder: FormBuilder,
    private userProfilesStore: UserProfilesStore,
    private dialog: MatDialog,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.updateAttributionForm = this.formBuilder.group({
      code: ['', Validators.required],
      description: ['', Validators.required],
    });

    this.getAttributions();
  }

  getAttributions() {
    this.userProfilesStore.getListAttributions().then(
      (data) => {
        this.attributionsList = data;
      },
      (error) => console.error(error)
    );
  }

  updateAttribution() {
    if (this.updateAttributionForm.valid) {
      let code = this.updateAttributionForm.controls.code.value;
      let description = this.updateAttributionForm.controls.description.value;

      let attributionToUpdate: AttributionTypeDTO = {
        id: code,
        name: description,
        status: statusEnum.N,
      };

      this.userProfilesStore.updateAttribution(attributionToUpdate).subscribe(
        (data: boolean) => {
          if (data) {
            this.getAttributions();
            const dialogConfig = new MatDialogConfig();
            dialogConfig.width = '90%';
            dialogConfig.maxWidth = '450px';
            dialogConfig.data = {
              text: this.translate.instant('dialog.manageAttributions.success').toUpperCase(),
              icon: 'icon-ic_circle_check',
            };
            this.dialog.open(ResponseDialogComponent, dialogConfig);
            this.updateAttributionForm.reset();

            Object.keys(this.updateAttributionForm.controls).forEach((key) => {
              this.updateAttributionForm.get(key).setErrors(null);
            });
          }
        },
        (error) => {
          const dialogConfig = new MatDialogConfig();
          dialogConfig.width = '90%';
          dialogConfig.maxWidth = '450px';
          dialogConfig.data = {
            text: this.translate.instant('dialog.manageAttributions.error'),
            icon: 'icon-ic_circle_cross',
          };
          this.dialog.open(ResponseDialogComponent, dialogConfig);
        }
      );
    }
  }
}
